import './Statistics.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import StatisticsCard from '../atoms/StatisticsCard/StatisticsCard';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get } from '../../utils';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
const TABLET_BREAKPOINT = {
  max: 767,
  min: 0
};
const TABLE_PORTRAIT_BREAKPOINT = {
  max: 1282,
  min: TABLET_BREAKPOINT.max + 1
};
const DESKTOP_BREAKPOINT = {
  max: 1482,
  min: TABLE_PORTRAIT_BREAKPOINT.max + 1
};
const EXTRA_BREAKPOINT = {
  max: 10000,
  min: DESKTOP_BREAKPOINT.max + 1
};
const Statistics = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const items = get(props.fields, "data.item.children", []);
  const heading = get(props.fields, "data.item.heading.jss");
  const description = get(props.fields, "data.item.description.jss");
  const isDetSite = get(props.params, 'RenderingStyle') === 'DDA';
  const getClass = type => {
    return `statistics__${type}--${items.length}-columns`;
  };
  let eventsAnalytics = get(props.fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: props.params['Anchor Url Parameter'],
    isDetSite: isDetSite
  }, /*#__PURE__*/React.createElement("div", {
    className: "statistics module-group"
  }, items.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, heading && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    className: "statistics__title",
    field: heading
  }), description && !!description.value ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "statistics__description",
    field: description
  }) : heading && heading.value ? /*#__PURE__*/React.createElement("div", {
    className: "statistics__gap"
  }) : null, items.length < 5 && /*#__PURE__*/React.createElement("div", {
    className: `statistics__list ${getClass("list")}`
  }, items.map((item, index) => /*#__PURE__*/React.createElement(StatisticsCard, {
    key: index,
    value: item.statNumber.jss,
    title: item.statTitle.jss,
    description: item.description.jss,
    compactHeader: items.length === 2,
    isDetSite: isDetSite
  }))), items.length > 2 && /*#__PURE__*/React.createElement("div", {
    className: `statistics__carousel ${getClass("carousel")}`
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, _ref => {
    let {
      renderDots,
      renderCarousel,
      renderNextButton,
      renderPreviousButton
    } = _ref;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "statistics__btn-wrapper"
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNextPrevious"], props.params), "previous"), false, false, null, isDetSite), renderNextButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNextPrevious"], props.params), "next"), false, false, null, isDetSite)), renderCarousel(items.map((item, index) => /*#__PURE__*/React.createElement(StatisticsCard, {
      key: index,
      value: item.statNumber.jss,
      title: item.statTitle.jss,
      description: item.description.jss,
      compactHeader: items.length === 2,
      isDetSite: isDetSite
    })), {
      responsive: {
        extra: {
          breakpoint: EXTRA_BREAKPOINT,
          items: items.length > 4 ? 4 : items.length
        },
        desktop: {
          breakpoint: DESKTOP_BREAKPOINT,
          items: items.length > 3 ? 3 : items.length
        },
        table_portrait: {
          breakpoint: TABLE_PORTRAIT_BREAKPOINT,
          items: items.length > 2 ? 2 : items.length
        },
        tablet: {
          breakpoint: TABLET_BREAKPOINT,
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "module-group no-padding-bottom"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["operatingOptionsNavigatorBubbles"], props.params)), [], isDetSite))));
  })))));
};
export default Statistics;
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter,
    isDetSite
  } = _ref2;
  const commonStyles = isDetSite ? "c1hcuglw" : "c1835klt";
  const ltrStyles = isDetSite ? "log5xkm" : "lpk2ar3";
  const rtlStyles = isDetSite ? "r3116" : "r1amj9vk";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    anchorUrlParameter: anchorUrlParameter
  }, children);
};